import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledTabContainer = styled.div<{ $withExpandMenu?: boolean }>`
  display: flex;
  height: calc(100dvh - 136px);

  ${({ $withExpandMenu }) =>
    $withExpandMenu &&
    `
    & > div:first-child > div {
      z-index: 1;
    }
  `}
`;

export const StyledManagementHeader = styled.div`
  position: absolute;
  height: ${theme.variables.height_1};
  margin: 20px;
`;

export const StyledManagementLinkHeader = styled.div`
  height: ${theme.variables.height_1};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  margin: 20px;
`;

export const StyledManagementPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  & .management-content {
    margin: 20px;
    height: 100%;
    overflow: auto;
  }
`;

export const StyledTabsContainer = styled.div`
  position: relative;
`;

export const StyledCreateButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 4px;
`;

export const StyledMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const StyledLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
